/** Keep saved column selections compatible with the Buy Strategy rename. */
export function normalizeDagColumnIds(columnIds: string[]): string[] {
  return Array.from(
    new Set(
      columnIds.map(id => (id === 'stocking_strategy' ? 'buy_strategy' : id))
    )
  )
}
